import { apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_AdvisorConfiguration, DBDef_AdvisorConfiguration } from '@app/org-shared';
export const dispatch_onAdvisorConfigurationChanged = new ThunderDispatcherV3('__onAdvisorConfigurationUpdated');
export class ModuleFE_AdvisorConfiguration_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_AdvisorConfiguration, dispatch_onAdvisorConfigurationChanged);
        this._v1 = {
            getAdvisorConfiguration: apiWithQuery(ApiDef_AdvisorConfiguration._v1.getAdvisorConfiguration),
        };
    }
}
export const ModuleFE_AdvisorConfiguration = new ModuleFE_AdvisorConfiguration_Class();
//# sourceMappingURL=ModuleFE_AdvisorConfiguration.js.map